import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { Invoice } from 'pipaylib/domain/invoice';
import { IonModal, ToastController } from '@ionic/angular';
import { AppdataService } from 'src/app/services/appdata.service';

@Component({
  selector: 'app-partywiseinvoicecard',
  templateUrl: './partywiseinvoicecard.component.html',
  styleUrls: ['./partywiseinvoicecard.component.scss'],
})
export class PartywiseinvoicecardComponent implements OnInit, OnChanges {
  @ViewChild(IonModal) modal: any;
  @Input()invoice: Invoice | any;
  @Input() selectAll: boolean;
  @Output()selectedInvoicesEmitter: EventEmitter<{
    selectedInvoice?: Invoice;
    deselectedInvoice?: Invoice;
  }> = new EventEmitter<{
    selectedInvoice?: Invoice;
    deselectedInvoice?: Invoice;
  }>();
  selected: boolean;
  valueChanged: boolean;
  showEditPriceModal: boolean;
  canDismissEditPriceModal: boolean;
  selectedInv: any;
  constructor(private toastController: ToastController, public dataService: AppdataService,) { }

  ngOnInit() {
    this.valueChanged = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectAll) {
      this.selected = changes.selectAll.currentValue;
    }
  }

  checkDueDate() {
    const today = new Date();
    const dueDate = new Date(this.invoice.duedate);
    if (today >= dueDate) {
      return true;
    }
    return false;
  }

  onSelect() {
    if (this.selected) {
      this.selectedInvoicesEmitter.emit({
        selectedInvoice: {...this.invoice, partialamt: this.invoice['partialamt'] },
      });
    } else {
      this.invoice.partialamt = this.invoice.payableamt;
      this.selectedInvoicesEmitter.emit({
        deselectedInvoice: this.invoice,
      });
    }
  }

  onApply() {
    this.onSelect();
    // this.valueChanged = false;
  }

  async checkAmount(event: any) {
    const inputValue = parseFloat(event.target.value);
    this.valueChanged = true;
    // this.onSelect();
    if (inputValue > this.selectedInv['payableamt']) {
      const toast = await this.toastController.create({
        message: 'The amount entered exceeds the payable amount.',
        duration: 2000,
        color: 'danger'
      });
      await toast.present();
      // Optionally, reset the input to the previous valid value
      this.selectedInv['partialamt'] = this.selectedInv['payableamt'];
    }
    if (inputValue === 0) {
      const toast = await this.toastController.create({
        message: 'The amount entered cannot be zero.',
        duration: 2000,
        color: 'danger'
      });
      await toast.present();
    }
  }

  enableEdit(invoice: any) {   
    // console.log('edit invoice' + JSON.stringify(this.invoice))
    this.selectedInv = { ...invoice }; 
    // console.log('clone invoice' + JSON.stringify(this.selectedInv))
    this.showEditPriceModal = true;
  }

  saveEdit() {    
    this.invoice.partialamt = this.selectedInv.partialamt;
    this.onSelect();
    // console.log('save invoice' + JSON.stringify(this.invoice))
    }
  

  closeEditPriceModal() {
    this.showEditPriceModal = false;
  }

}
